import React from 'react';
import SupplierForm from '../../components/SupplierForm';

const EditSupplier: React.FC = () => <SupplierForm />;

export default EditSupplier;
